import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

const UseWindowDimensions = () => {
  const theme = useTheme();
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {...windowDimensions, theme};
}

export default UseWindowDimensions;
